import SelectBox from 'components/global/SelectBox';
import React, { useState } from 'react';
import DigitalScreen from 'assets/images/digitalScreen.png';
import Vehicle from 'assets/images/vehicle.png';
import Board from 'assets/images/boards.png';
import { useDispatch, useSelector } from 'react-redux';
import { setNextCompaignTab } from 'redux/actions/newCompaignActions';


const mediums = [
    {
        id : 1 ,
        name : 'Digital Screen' ,
        image : DigitalScreen
    } , 
    {
        id : 2 ,
        name : 'Vehicle' ,
        image : Vehicle
    } , 
    {
        id : 3 ,
        name : 'Billboards' ,
        image : Board
    } , 
]

const CompaignDetails = () => {
    const [name , setName] = useState('');
    const [industry , setIndustry] = useState('');
    const [medium , setMedium] = useState(mediums[0]);
    const dispatch = useDispatch();

    const submitHandler = e => {
        e.preventDefault();
        dispatch(setNextCompaignTab())
    }

    return (
        <div className='sm:p-8 p-4 '>
            <form onSubmit={submitHandler}>
                <div className='flex items-center gap-4 sm:flex-row flex-col'>
                    <div className='flex-1 w-full'>
                        <input 
                        type="text" 
                        placeholder='Compaign Name'
                        value={name}
                        onChange={e => setName(e.target.value)}
                        className='input'
                        // required
                        />
                    </div>
                    <div className='flex-1 w-full'>
                        <SelectBox
                        options={[
                            { value : '1' , label : 'Industry 1'} ,
                            { value : '2' , label : 'Industry 2'} ,
                            { value : '3' , label : 'Industry 3'} ,
                            { value : '4' , label : 'Industry 4'} ,
                        ]}
                        value={industry}
                        setValue={setIndustry}
                        // required
                        />
                    </div>
                </div>
                <div className='mt-12'>
                    <p className='text-lg font-bold text-primary text-center'>Choose Medium</p>
                    <div className='grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-12 mt-12'>
                        {
                            mediums?.map(item => (
                                <div 
                                key={item.id} 
                                className={`border border-dark p-2 rounded-md flex flex-col gap-2 items-center cursor-pointer
                                ${medium?.id === item?.id ? 'border-2 border-primary' : ''}
                                `}
                                onClick={() => setMedium(item)}
                                >
                                    <div>
                                        <img 
                                        src={item?.image} 
                                        alt=""
                                        className='w-full h-auto' 
                                        />
                                    </div>
                                    <p>{item?.name}</p>
                                </div>
                            ))
                        }
                    </div>
                    <div className='mt-12 text-center'>
                        <button 
                        className="btn-primary py-1.5 w-[150px]"
                        type='submit'
                        >
                            Next
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default CompaignDetails